export default "__VITE_ASSET__D6TLJQo8__"